import Axios from "axios";
import {
    SET_PUR_SUPPLIER_LIST_REPORT,
    UNSET_PUR_SUPPLIER_LIST_REPORT,
  } from "@/store/mutation-types";
import {getPurSupplierListReport} from "@/store/api";

const state = {
    getPurSupplierListReport: [],
};

const getters = {
    getPurSupplierListReport(state) {
        return state.getPurSupplierListReport;
    },
};

const mutations = {
    [SET_PUR_SUPPLIER_LIST_REPORT](state, data) {
        state.getPurSupplierListReport = data;
    },
    [UNSET_PUR_SUPPLIER_LIST_REPORT](state) {
        state.getPurSupplierListReport = [];
    },
};

const actions = {
    getPurSupplierListReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getPurSupplierListReport}`, { params: data })
                .then((response) => {
                    commit(SET_PUR_SUPPLIER_LIST_REPORT, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_SUPPLIER_LIST_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};